import React from "react";
import Cookies from "js-cookie";
import { Navigate, useLocation } from "react-router-dom";
import { ACC_TKN } from "../../utils/API";

export function AuthLazyComponent({ component: Component, props = {} }) {
    const location = useLocation();
    const token = Cookies.get(ACC_TKN);
    if (!token) return <Navigate to="/login" replace state={{ prev: location.pathname }} />
    return <Component {...props} />
}
